import useFetcher from 'app/_utils/data/useFetcher';

import { useState } from 'react';

const url = `${process.env.ZEUS_API_URL}/v2/system/post-login`;

/**
 * Handles updating authorizations for users (i.e., org membership, org/workspace/product roles)
 */
export const useUpdatePostLogin = () => {
  const { fetcher } = useFetcher();
  const [isLoading, setIsLoading] = useState(false);

  const update = async () => {
    setIsLoading(true);

    try {
      await fetcher(url, {
        method: 'POST',
        // No body needs to be sent. All the backend needs is the access token
      });
    } finally {
      setIsLoading(false);
    }
  };

  return { update, isLoading };
};
